
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../GlobalContext';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import config from '../../config'; // Path to your config file
import { GetAll } from '../../service/CountryService'; // Path to your CountryService file
import { GetById, Update } from '../../service/StateService'; // Path to your CountryService file

export default function EditCountry() {
  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  // country
  const [countryId, setCountryId] = useState('');
  const [countrys, setCountrys] = useState([]);
  const [name, setName] = useState('');
  const { id } = useParams();
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('active');

  //state
  const [state, setState] = useState({});

  const fetchStateById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      console.log("id", response);
      if (response.status === 200) {
        setState(response.state);
        setName(response.state.name);
        setCountryId(response.state.country.id);
        setStatus(response.state.status);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  // fetch country 
  const FetchCountry = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);

      if (response && Array.isArray(response.countrys)) {
        // Filter only active categories
        const activeCountrys = response.countrys.filter(cat => cat.status === "active");
        setCountrys(activeCountrys);
      } else {
        setAppError(true);
        setAppErrorMessage('No Country Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };


  const saveState = async (event) => {
    event.preventDefault();

    if (!countryId) {
      setAppError(true);
      setAppErrorMessage("Please select your Country.");
      setAppErrorTitle("Validation Error");
      setAppErrorMode("error");
      setIsLoading(false);
      return;
    }

    //check whether the name is filled and atleast have 3 chars
    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }


    setIsLoading(true);
    try {
      const response = await Update(id, countryId, name, status);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "State Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/setting/state/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add state. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add country. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchCountry(); // Call function to fetch countrys when component mounts
  }, []);

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchStateById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> State Manage | {config.appName}</title>
      </Helmet>

      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Edit State</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/setting/state/list"> State List </Link> / State Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='form'>
                  <form onSubmit={saveState} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Country</label>
                          <select
                            className="form-control"
                            value={countryId} // Ensure this country is defined
                            onChange={(e) => setCountryId(e.target.value)} // Update correctly
                          >
                            <option value="">Select Country</option>
                            {countrys.map(countryOption => (
                              <option key={countryOption.id} value={countryOption.id}>
                                {countryOption.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input className='form-control' type='text' value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <br></br>
                          <input type='radio' name='status' value="active" onChange={(e) => setStatus(e.target.value)} checked={status === 'active'} /> Active &nbsp;&nbsp;
                          <input type='radio' name='status' value="inactive" onChange={(e) => setStatus(e.target.value)} checked={status === 'inactive'} /> Deactive
                        </div>
                      </div>

                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'> <i className="ri-reset-right-line"></i> Reset </button>

                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'> <i className="ri-check-fill"></i> Update State </button>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}